import React, { PureComponent } from 'react';
import { Alert, Button } from 'antd';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';
import Spacing from 'components/common/Spacing';
import withGetCdsSearchUrl from 'graphql/hocs/emr/withGetCdsSearchUrl';
import DropdownListWrapper from './DropdownListWrapper';
import CdsSearchForm from './CdsSearchForm';

@withGetCdsSearchUrl
@inject('uiStore')
class CdsDropdown extends PureComponent {
  static propTypes = {
    onGetCdsSearchUrl: PropTypes.func.isRequired,
    uiStore: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.cdsSearchForm = React.createRef();
    this.state = {
      errorMessage: '',
    };
  }

  handleOpenCdsModal = () => {
    const { onGetCdsSearchUrl, uiStore } = this.props;
    this.cdsSearchForm.current.validateFields(async (err, values) => {
      if (!err) {
        const { age, ageUnit, codes, sex, searchTerm } = values;
        if (!searchTerm && (!codes?.length || !codes[0]?.code)) {
          this.setState({ errorMessage: 'A search term or code is required.' });
        } else {
          const input = { age, ageUnit, sex, searchTerm, codes };
          const { data } = await onGetCdsSearchUrl({ variables: { input } });
          const url = data.getCdsSearchUrl;
          uiStore.openGlobalModal('cdsIframe', { url }, { width: '90%', closable: false });
        }
      }
    });
  };

  renderErrorMessage() {
    const { errorMessage } = this.state;
    if (errorMessage) {
      return (
        <>
          <Alert message={errorMessage} type="error" />
          <Spacing size={20} />
        </>
      );
    }
    return null;
  }

  render() {
    return (
      <DropdownListWrapper>
        {this.renderErrorMessage()}
        <CdsSearchForm ref={this.cdsSearchForm} />
        <Button type="primary" onClick={this.handleOpenCdsModal} block>
          Search
        </Button>
      </DropdownListWrapper>
    );
  }
}

export default CdsDropdown;
